<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">
      <div class="bg-success m-b-30">
        <div class="container">
          <div class="row p-b-60 p-t-60">
            <div class="col-md-6 text-center mx-auto text-white p-b-30">
              <h3 class="h3">Enrollee Uploads CSV</h3>

              <div class="form-dark">
                <div class="input-group input-group-flush mb-3"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container">
        <a class="btn btn-dark my-3" href="/Sample_Data.csv"
          >Download Sample Format</a
        >
        <div class="row list">
          <div class="col-lg-12 col-md-12">
            <div class="card m-b-30">
              <div class="card card-header">
                <div class="col-md-3">
                  <label for=""
                    >Start Upload From Number?: {{ json_index }}
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="json_index"
                  />
                </div>
                <div class="col-md-12 my-2">
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text" id="inputGroupFileAddon01"
                        >Upload</span
                      >
                    </div>
                    <div class="custom-file">
                      <input
                        type="file"
                        @change="handleFileUpload"
                        accept=".csv"
                        class="custom-file-input"
                        id="inputGroupFile01"
                        aria-describedby="inputGroupFileAddon01"
                      />
                      <label class="custom-file-label" for="inputGroupFile01"
                        >Choose file (Must be CSV)</label
                      >
                    </div>
                  </div>

                  <div v-if="clients.length > 1" class="my-2">
                    <p class="h6">
                      Total to be Uploaded: {{ clients.length }}
                    </p>
                    <p class="h6" v-if="running">
                      Uploading row {{ json_index + 1 }} of {{ clients.length }}<span v-if="failed"> — {{ failed }} failed</span>…
                    </p>
                    <p class="h6" v-else>{{ json_index }} of {{ clients.length }} already uploaded</p>
                  </div>
                </div>

                <p class="d-flex" style="gap: 8px;">
                  <button class="btn btn-dark btn-block" :disabled="running || !clients.length" @click="autoUpdate">
                    Update All
                  </button>
                  <button class="btn btn-outline-danger" v-if="running" @click="stopUpload">
                    Stop
                  </button>
                </p>

                <div v-if="!running && failedItems.length" class="alert alert-danger">
                  <div class="d-flex align-items-center mb-1">
                    <strong class="mr-auto">{{ failedItems.length }} row(s) failed</strong>
                    <button type="button" class="btn btn-sm btn-outline-danger" @click="retryFailed">
                      Retry Failed
                    </button>
                  </div>
                  <ul class="mb-0 pl-3 small" style="max-height: 150px; overflow-y: auto;">
                    <li v-for="item in failedItems" :key="item.index">
                      Row {{ item.index + 1 }} ({{ item.row.firstname }} {{ item.row.lastname }}) — {{ item.message }}
                    </li>
                  </ul>
                </div>
              </div>

              <div class="card-body">
                <div class="table-responsive">
                  <div class="col-md-12">
                    <b-table striped hover :items="clients"></b-table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="vld-parent">
            <loading
              :active.sync="isLoading"
              loader="dots"
              :can-cancel="false"
              :is-full-page="fullPage"
            ></loading>
          </div>
        </div>
      </div>
    </main>
  </section>
</template>
  
  <script>
import Navbar from "@/views/Navbar.vue";

// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
// Init plugin
import Papa from "papaparse";

let agency = JSON.parse(localStorage.getItem("agency"));

export default {
  components: {
    Loading,
    Navbar,
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      user: null,
      clients: [],
      json_index: 0,
      running: false,
      stopRequested: false,
      failed: 0,
      failedItems: [],
    };
  },
  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
  },

  methods: {
    async handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;
      this.isLoading = true;
      try {
        this.clients = await this.parseCSVtoJSON(file);
        this.json_index = 0;
        this.failed = 0;
        this.failedItems = [];
      } catch (error) {
        console.error(error);
        this.$toasted.error("Could not read the CSV file.", { position: "top-center", duration: 4000 });
      } finally {
        this.isLoading = false;
      }
    },

    parseCSVtoJSON(file) {
      return new Promise((resolve, reject) => {
        Papa.parse(file, {
          header: true,
          skipEmptyLines: true,
          complete: (result) => resolve(result.data),
          error: (error) => reject(error),
        });
      });
    },

    // Retries a single row up to 3 times before giving up, same pattern used
    // for bulk staging activation.
    async uploadOne(row) {
      const maxAttempts = 3;
      for (let attempt = 1; ; attempt++) {
        try {
          await this.axios.post(`/api/v1/auth/multiverse/add`, {
            firstname: row.firstname,
            lastname: row.lastname,
            middlename: row.middlename,
            gender: row.gender,
            dob: row.dob,
            expiry_date: row.expiry_date,
            id_card_number: row.id_card_number,
            CATEGORY: row.CATEGORY,
            provider_id: row.provider_id,
            place_of_work: row.place_of_work,
            user_image: row.user_image,
            plan_type: row.plan_type,
            nimc_number: row.nimc_number,
            phone_number: row.phone_number,
            salary_number: row.salary_number,
            agency_id: agency.id,
            state: agency.state,
            enrolled_by: this.user.id,
            sector: row.sector,
            sectorType: row.sectorType,
            marital_status: row.marital_status,
            localgovt: row.localgovt,
            user_role: 0,
          });
          return;
        } catch (err) {
          if (attempt >= maxAttempts) {
            const data = err.response && err.response.data;
            const message = (data && (data.message || (data.errors && Object.values(data.errors).flat()[0]))) || "Request failed";
            throw new Error(message);
          }
          await new Promise((resolve) => setTimeout(resolve, 1000 * attempt));
        }
      }
    },

    async autoUpdate() {
      if (this.running || !this.clients.length) return;
      const remaining = this.clients.length - this.json_index;
      if (!confirm(`Upload ${remaining} enrollee(s) starting from row ${this.json_index + 1}, one at a time?`)) return;

      this.running = true;
      this.stopRequested = false;
      this.failed = 0;
      this.failedItems = [];

      while (this.json_index < this.clients.length && !this.stopRequested) {
        const index = this.json_index;
        const row = this.clients[index];
        try {
          await this.uploadOne(row);
        } catch (err) {
          this.failed++;
          this.failedItems.push({ index, row, message: err.message });
        }
        this.json_index++;
      }

      this.running = false;
      const uploaded = this.json_index - this.failed;
      if (this.failed) {
        this.$toasted.error(`${uploaded} uploaded, ${this.failed} failed`, { position: "top-center", duration: 5000 });
      } else if (uploaded) {
        this.$toasted.success(`${uploaded} enrollee(s) uploaded successfully`, { position: "top-center", duration: 3000 });
      }
    },

    stopUpload() {
      this.stopRequested = true;
    },

    async retryFailed() {
      if (this.running || !this.failedItems.length) return;
      const items = this.failedItems;
      if (!confirm(`Retry ${items.length} failed row(s)?`)) return;

      this.running = true;
      this.stopRequested = false;
      const stillFailed = [];

      for (const item of items) {
        if (this.stopRequested) {
          stillFailed.push(item);
          continue;
        }
        try {
          await this.uploadOne(item.row);
        } catch (err) {
          stillFailed.push({ ...item, message: err.message });
        }
      }

      this.failedItems = stillFailed;
      this.failed = stillFailed.length;
      this.running = false;
      const succeeded = items.length - stillFailed.length;
      if (stillFailed.length) {
        this.$toasted.error(`${succeeded} uploaded, ${stillFailed.length} still failing`, { position: "top-center", duration: 5000 });
      } else {
        this.$toasted.success(`${succeeded} enrollee(s) uploaded successfully`, { position: "top-center", duration: 3000 });
      }
    },
  },
};
</script>
  